import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TimelineLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {BookOfShadowsGameModuleConfig} from "../../../BookOfShadowsGameModuleConfig";
import {BookOfShadowsGameConfig} from "../../../BookOfShadowsGameConfig";

export class BookOfShadowsReelLockButtonIdleAnimationController implements GameRoundPresentation {
    private _tl: TimelineLite;

    /**
     * @inheritDoc
     */
    public getAnimation(): TimelineLite | null {
        const id: number = MathHelper.randomIntInRange(0, 4),
            delay: number = MathHelper.randomIntInRange(3, 7);

        if (BookOfShadowsGameConfig.instance.LOCKED_REEL.indexOf("1") > -1) {
            return null;
        }

        this._tl = new TimelineLite();

        this._tl.add(() => BookOfShadowsGameModuleConfig.reelLockController.playLockIdleAnimation(id), delay);
        // doing this intentionally, as the above delay shouldn't impact the BetLineWin idle loop.
        // if there is no BetLineWin from idle loop, then this doesn't matter.
        this._tl.totalDuration(0.001);

        return this._tl;
    }

    /**
     * @inheritDoc
     */
    public abort(): TimelineLite | null {
        this._tl?.kill();

        return null;
    }
}